import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  template: `
    <div class="app-shell">
      <header class="topbar">
        <a routerLink="/" class="brand">
          <span class="brand-mark image-mark">
            <img src="assets/danii-avatar.jpg" alt="DaniiPlace Avatar" />
          </span>
          <span class="brand-copy">
            <strong>DaniiPlace</strong>
          </span>
        </a>

        <nav class="nav">
          <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
          <a routerLink="/kanaele" routerLinkActive="active">Kanäle</a>
          <a routerLink="/spielshows" routerLinkActive="active">Shows</a>
          @if (auth.canUseCreatorSpace()) {
            <a routerLink="/show-lobby" routerLinkActive="active" class="creator-space-link">Show Lobby</a>
          }
          @if (auth.isAdmin()) {
            <a routerLink="/fragenkatalog" routerLinkActive="active" class="creator-space-link">Fragenkatalog</a>
          }
          @if (auth.canUseCreatorSpace()) {
            <a routerLink="/creator-space" routerLinkActive="active" class="creator-space-link">Creator Space</a>
          }
          <a routerLink="/login" routerLinkActive="active" class="login-pill">{{ auth.activeUser().role === 'guest' ? 'Login' : auth.activeUser().username }}</a>
        </nav>
      </header>

      <main>
        <router-outlet />
      </main>
    </div>
  `
})
export class AppComponent {
  readonly auth = inject(AuthService);
}
